import React from 'react';
import clsx from 'clsx';
import { useSSE } from 'src/hooks/useSSE';
import IconNotification from '../../atom/icons/Notification';

interface NotificationIndicatorProps {
  onClick: () => void;
  isActive: boolean;
  id?: string;
}

/**
 * Real-time notification indicator component
 * Uses SSE Redux state for real-time unread count
 *
 * Important: Does NOT fetch API data here to avoid conflicts with optimistic updates
 * API data is fetched in Notification.tsx when dropdown opens
 */
export const NotificationIndicator: React.FC<NotificationIndicatorProps> = ({ onClick, isActive, id }) => {
  // Use SSE Redux state as single source of truth for badge
  const { notificationStatus, isConnected } = useSSE();

  // ✅ FIX: Use Redux state directly - no API call here
  // This ensures optimistic updates work immediately
  const unreadCount = notificationStatus.unreadCount;

  return (
    <div id={id} className='relative flex items-center justify-center mr-10 ml-10'>
      <button
        type='button'
        onClick={onClick}
        className={clsx('w-[40px] h-[40px] rounded-full flex items-center justify-center hover:bg-[#171D21]', isActive && 'bg-[#171D21]')}
      >
        <IconNotification />
        {unreadCount > 0 && <div className='w-12 h-12 rounded-full border-2 border-[#171D21] bg-red-40 absolute right-8 top-6' />}
      </button>

      {/* Optional: Small indicator for WebSocket connection status */}
      <div
        className={clsx('absolute w-2 h-2 rounded-full bottom-0 right-0', isConnected ? 'bg-green-500' : 'bg-yellow-500')}
        title={isConnected ? 'Real-time connected' : 'Using fallback polling'}
      />
    </div>
  );
};
